import React, { Component } from "react";
import classnames from "classnames";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser, addLogs} from "../../actions/authActions";
import $ from 'jquery';
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Util from "../../streaming/Util";

class SessionList extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
        sessionData: [],
        allData: '',
        sessionId:'',
        show_join_loader:false,
        show_login_loader:false
      }

      this.sessionDataStore = SessionDataStore.getInstance();
  }

  logout(){
    localStorage.removeItem("userData");
    localStorage.removeItem("sessionList");
    window.location.href  = window['electron'] ? 'index.html' : '/login';
  }

  handleChange = (id, type) => {
    this.setState({sessionId: id});

    if (type === 'join') {
        this.setState({show_join_loader:true});
    } else {
        this.setState({show_login_loader:true});
    }
    
    setTimeout(()=>{
      this.fetchSessionDetails();
    }, 200);
  };

  componentDidMount(){
 
    // let localstoragedata = JSON.parse(localStorage.getItem('sessionList'));
    let localstoragedata = JSON.parse(localStorage.getItem('userData'));

    this.setState({
        sessionData: localstoragedata.sessionData,
        allData: localstoragedata
    });

    setTimeout(()=>{
      this.state.sessionData.map((sessData, idx) => {
          if(idx == 1) {
              this.countdownTimer(sessData.scheduleDate);
          }
      });
    }, 200);
  } 

  fetchSessionDetails() {
    
    // let token = JSON.parse(localStorage.getItem('sessionList')).token;
    let token = JSON.parse(localStorage.getItem('userData')).token;

    axios.defaults.headers.common['Authorization'] = token;              
    axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+this.state.sessionId+"/individualsessiondetail")          
      .then(res => {
        let sessionDetail = JSON.stringify(res.data.responseData);
        console.log('---------sessionDetail--------------', res.data.responseData);

        let sessionDetail1 = JSON.parse(sessionDetail);

        sessionDetail1.token = token;

        let addObject = {"sessionId": sessionDetail1.sessionData.id, "event": "status", "eventType": "login", "userId": sessionDetail1.id, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
        this.sessionDataStore.addSessionData(addObject);

        localStorage.setItem("userData", JSON.stringify(sessionDetail1));

        this.props.history.push("/pre-screen");
      })
      .catch(err =>{
          this.setState({show_join_loader:false, show_login_loader:false});
          console.log('Error in fetching class details - ', err);
      });
  }

  countdownTimer(sessionDate) {

    var deadline = new Date(sessionDate).getTime();
    var seconds,
        minutes,
        hours,
        now,
        timeRemaining;

    var x = setInterval(function() {
          now = new Date().getTime(); 
          timeRemaining = deadline - now;

          if (timeRemaining < 0) {
              clearInterval(x);
          } else {
              seconds = ("0" + (Math.floor((timeRemaining / 1000) % 60) % 60)).slice(-2);
              minutes = ("0" + Math.floor((timeRemaining / 60000) % 60)).slice(-2);
              hours = Math.floor((timeRemaining / 3600000));
              
              if(hours >= 100) {
                hours = ("0" + hours).slice(-3);
              } else {
                hours = ("0" + hours).slice(-2);
              }

              $('.hour').text(hours);
              $('.min').text(minutes);
              $('.sec').text(seconds);
          }
    }, 1000); 
  }

render() {

    let sessionData = this.state.sessionData.map((sessDta, idx) => {

        const { id, name, hostFirstName, hostLastName, scheduleDate, sessionImage} = sessDta;

        if(new Date(scheduleDate).getTime() < new Date().getTime()) {
          return (<div className="col-md-6" key={idx}>
                        <div className="left-container background-gray radius-10 p-4" id={"sessionDta-"+id}>
                          <div className="d-flex">
            								<h3 className="white_heading">{name}</h3>
            								<p className="mb-0 ml-2 mt-2 small_gray_font">By {hostFirstName} {hostLastName}</p>
            							</div>
                          <img src={ sessionImage != null ? sessionImage : 'images/virdio.jpg'} className="w-100 my-3 radius-10" />
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <p className="mb-0 small_gray_font"></p>
                            <p className="text-white font-20 mb-0">In Progress</p>
                          </div>
                          <div className="mt-4 d-flex justify-content-end">
                            <div className={classnames({'circle mt-3':true, 'mx-3':true, 'd-none':!this.state.show_join_loader})}></div>
                            <button className="join_button ml-2 mt-3" id={id} onClick={this.handleChange.bind(this, id, 'join')}>Join</button>
                          </div>
                        </div>
                      </div>
                  );
        } else {
            return (
              <div className="col-md-6" key={idx}>
                        <div className="left-container background-gray radius-10 p-4" id={"sessionDta-"+id} key={idx}>
	                        <div className="d-flex">
            								<h3 className="white_heading">{name}</h3>
            								<p className="mb-0 ml-2 mt-2 small_gray_font">By {hostFirstName} {hostLastName}</p>
            							</div>
                          <img src={ sessionImage != null ? sessionImage : 'images/virdio.jpg'} className="w-100 my-3 radius-10" />
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <p className="mb-0 small_gray_font"></p>
                            <p className="small_gray_font mb-0"><img src="./images/time.png" className="mr-3 translate-0" />
                              <span className="hour inline-block position-relative"></span> :
                              <span className="min inline-block position-relative"></span> :
                              <span className="sec inline-block position-relative"></span>
                            </p>
                          </div>
                          <div className="mt-4 d-flex justify-content-end">
                            <div className={classnames({'circle':true, 'mx-3 mt-3':true, 'd-none':!this.state.show_login_loader})}></div>
                            <button className="join_button mt-3" id={id} onClick={this.handleChange.bind(this, id, 'login')}>Login</button>
                          </div>
                        </div>
                      </div>
               );
        }
    })
  return (
       <div>
		    <div className="container-fluid px-5 py-5">
				<div className="background-gray p-4 radius-10">
					<img src="./images/login-logo.png" className="logo-icon" />					
				</div>
				<div className="mt-3 py-4">
					<p className="white_heading border_bottom_purple pb-1 font-20">"Hi {this.state.allData.firstName}, you have an ongoing class and another class starting in {this.state.allData.nextSessionInMinutes} minutes, please select one of the classes to join"</p>
				</div>
				<div className="">
					<div className="row">
						{sessionData}
					</div>
				</div>
				<button className="btn btn-outline-secondary font-weight-bold px-4 py-3 mt-4 font-20 rounded float-right" onClick={this.logout.bind(this)}>Leave</button>
			</div>                        
      </div>
    );
  }
}

SessionList.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  addLogs: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(
  mapStateToProps,
  { logoutUser,addLogs }
)(SessionList);